import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import HSCodeList from '~/containers/hsCodeList/hsCodeList';

export default class CustomersPage extends Component {
  render() {
    const createButton = (
      <Link to="/settings/hscodes/create">
        <Button color="primary">New HS Code</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar back="/settings" backText="Settings" title="HS Codes" button={createButton} />
        <HSCodeList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/hsCodes/hsCodes.jsx